import * as React from 'react';
import { createPortal } from 'react-dom';
import { getItem, removeItem } from '../helpers/webStorage';
import RemoveIcon from '../../../svg/icons/remove.svg';
import LoupeLogo from '../../../svg/icons/loupe-logo.svg';
import { GlobalMessage, CheckoutStorageStateKey } from '../types';

interface PageHeaderProps {
  hideCloseButton?: boolean;
  globalMessages?: GlobalMessage[];
  onCloseGlobalMessage?: (globalMessage: GlobalMessage) => void;
  closeBagButtonFromHeaderCallback?: () => void;
  globalMessagesDOM?: HTMLElement | null;
  headerCloseButton?: Element | null;
  pageTitle: string;
}

function PageHeader({
  hideCloseButton = false,
  globalMessages = [],
  onCloseGlobalMessage = (): void => {},
  closeBagButtonFromHeaderCallback = closeBagButtonFromHeader,
  globalMessagesDOM = document.getElementById('globalMessages'),
  headerCloseButton = document.querySelector('.page-top-header__close'),
  pageTitle
}: PageHeaderProps): React.ReactElement {
  React.useEffect(() => {
    /* istanbul ignore else */
    if (headerCloseButton) {
      headerCloseButton.classList[hideCloseButton ? 'add' : 'remove']('hide');
      headerCloseButton.addEventListener('click', closeBagButtonFromHeaderCallback);
    }
    return (): void => {
      /* istanbul ignore else */
      if (headerCloseButton) {
        headerCloseButton.removeEventListener('click', closeBagButtonFromHeaderCallback);
      }
    };
  }, [hideCloseButton, closeBagButtonFromHeaderCallback]);

  return (
    <>
      {globalMessagesDOM
        ? createPortal(
            globalMessages.map((globalMessage, index) => (
              <div key={`${globalMessage.message}_${index + 1}`} className="page-global-message">
                <h2 className="page-global-message__text">{globalMessage.message}</h2>
                <button
                  type="button"
                  aria-label="Close message"
                  className="page-global-message__close-button"
                  onClick={(): void => onCloseGlobalMessage(globalMessage)}
                >
                  <RemoveIcon className="page-global-message__close-icon" />
                </button>
              </div>
            )),
            globalMessagesDOM
          )
        : null}
      <div className="page-header-wrapper">
        <a href="/" className="page-logo">
          <LoupeLogo className="page-logo__icon" title="Loupe logo" />
        </a>
        <h1 className="page-title reservation__title">{pageTitle}</h1>
      </div>
    </>
  );
}

export function closeBagButtonFromHeader(): void {
  const checkoutCloseUrl = getItem(CheckoutStorageStateKey.CLOSE_BAG_URL) || '/';
  const sameDomainReferrer = document.referrer.includes(window.location.hostname);
  const closeFromCheckout = checkoutCloseUrl.includes('checkout');
  const closeFromOrderConfirmation = window.location.pathname.includes('orderConfirmation');
  removeItem(CheckoutStorageStateKey.CLOSE_BAG_URL);
  window.location.href =
    sameDomainReferrer && !closeFromCheckout && !closeFromOrderConfirmation ? checkoutCloseUrl : '/';
}

export default PageHeader;
